import { z } from 'zod';

export const HealthResponse = z.object({
  status: z.literal('ok'),
  d365Mode: z.enum(['mock', 'live']),
  directoryMode: z.enum(['mock', 'live']),
  authMode: z.enum(['entra', 'mock']),
  time: z.string().datetime(),
});
export type HealthResponse = z.infer<typeof HealthResponse>;

/** RFC 7807 problem details. */
export const Problem = z.object({
  type: z.string().default('about:blank'),
  title: z.string(),
  status: z.number().int(),
  detail: z.string().optional(),
  errors: z.array(z.object({ path: z.string(), message: z.string() })).optional(),
});
export type Problem = z.infer<typeof Problem>;
